<template>
  <router-view />
</template>

<script>
export default {
  name: "app-document"
};
</script>

<style lang="scss" scoped></style>
